import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { Injectable } from '@angular/core';
import { moduloGaritas } from '../diccionarios/balanzaModulo.js';
import { Observable } from 'rxjs';
import { IOrdenBalanza } from '../modelos/IOrdenBalanza';

@Injectable({
  providedIn: 'root',
})
export class OrdenBalanzaService {
  private diccionarioModulo: any;
  private url: string;
  private urlPortaCompras: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlPortaCompras = this._util.getPortalCompras();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.obtenerTodo
    );
  }

  obtenerPorId(id: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.obtenerPorId + id
    );
  }

  crearOrdenBalanza(request: IOrdenBalanza): Observable<IOrdenBalanza> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.crear,
      request
    );
  }

  actualizarOrdenBalanza(request: IOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.actualizar,
      request
    );
  }

  cerrarOrdenBalanza(request: IOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.cerrarOrden,
      request
    );
  }


  actualizarDatosBasicos(request: IOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.actualizarDatosBasicos,
      request
    );
  }

  borrarOrdenBalanza(id: number): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.eliminar + id,
      {}
    );
  }

  capturaDePesoSalida(payload): Observable<any> {
    //return of({}).pipe(delay(1000));
    return this._commom.peticionPutConHeader(
      this.url +
      this.diccionarioModulo.url.ordenesBalanza.pesoSalida, payload
    );
  }

  imprimirCapturaEntrada(request: IOrdenBalanza) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.imprimirEntrada,
      request
    );
  }

  imprimirCapturaSalida(request: IOrdenBalanza) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.imprimirSalida,
      request
    );
  }

  buscarFleteSap(request: any) {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.buscarFleteSap + request
    );
  }

  buscarOC(request: any) {
    return this._commom.peticionGetConHeader(
      this.urlPortaCompras + this.diccionarioModulo.url.ordenesBalanza.buscarOC + request
    );
  }

  buscarPorEstado(request: any, user: any) {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.buscarPorEstado + request + "&usuario=" + user
    );
  }

  buscarDesbloqueos(request: any, user: any) {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.buscarDesbloqueos + request + "&usuario=" + user
    );
  }

  reporte(tipopedido, tipoOrdenBalanza, cliente, material, nrOrden, fechaInicio, fechaFin) {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.reporte +
      "tipopedido=" + tipopedido +
      "&tipoOrdenBalanza=" + tipoOrdenBalanza +
      "&cliente=" + cliente +
      "&material=" + material +
      "&nrOrden=" + nrOrden +
      "&fechaInicio=" + fechaInicio +
      "&fechaFin=" + fechaFin
    );
  }

  reporteria(request): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.reporteria,
      request
    );
  }

  validacionMDI(request): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.urlPortaCompras + this.diccionarioModulo.url.ordenesBalanza.validacionMDI,
      request
    );
  }

  obtenerPeso(numero:number){
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.pesoBalanza+numero
    );
  }

  imprimirEtiqueta(numero:number): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.imprimirEtiqueta + numero,
      {}
    );
  }

  obtenerPesoByUser(usuario:string){
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.pesoBalanzaUser+usuario
    );
  }

  actualizarEstado(request: IOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.actualizarEstado,
      request
    );
  }

  reasignarBascula(request: IOrdenBalanza): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.reasignarBascula,
      request
    );
  }

  filtroOrdenesCerradas(request, usuario): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.filtrarOrdenesCerradas,request
    );
  }

}
